import React, { useEffect, useState } from "react";
import { FileWarning } from "lucide-react";
import { api } from "../../lib/api";

export const PolicyPreview = ({ policyId, versionId, fileType }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [text, setText] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let revoke = null;
    setBlobUrl(null); setText(null); setError("");
    if (!versionId) return undefined;
    const run = async () => {
      try {
        if (fileType === "pdf") {
          const res = await api.get(`/policies/${policyId}/file`, { params: { version_id: versionId, inline: true }, responseType: "blob" });
          revoke = URL.createObjectURL(res.data);
          setBlobUrl(revoke);
        } else {
          const { data } = await api.get(`/policies/${policyId}/text`, { params: { version_id: versionId } });
          setText(data);
        }
      } catch (err) {
        setError(err?.response?.data?.detail || "Preview unavailable");
      }
    };
    run();
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [policyId, versionId, fileType]);

  if (!versionId) return <div className="nv-card p-8 text-sm text-slate-500 text-center" data-testid="policy-preview-none">No approved version is available to you yet.</div>;
  if (error) return <div className="nv-card p-8 text-sm text-rose-700 text-center" data-testid="policy-preview-error">{error}</div>;
  if (fileType === "pdf") {
    return blobUrl
      ? <iframe title="Policy preview" src={blobUrl} className="w-full h-[70vh] rounded-xl border border-slate-200 bg-white" data-testid="policy-pdf-preview" />
      : <div className="nv-card p-8 text-sm text-slate-500 text-center animate-pulse">Loading preview…</div>;
  }
  if (!text) return <div className="nv-card p-8 text-sm text-slate-500 text-center animate-pulse">Loading preview…</div>;
  return (
    <div className="nv-card p-5" data-testid="policy-text-preview">
      <p className="text-[12.5px] uppercase tracking-wide text-slate-400 mb-3">Word document · text preview {text.extraction_status !== "complete" && "(incomplete)"}</p>
      {text.extraction_status === "failed" ? (
        <div className="flex items-center gap-2 text-sm text-rose-700"><FileWarning size={16} /> {text.extraction_error || "Text could not be extracted."} Download the original to read it.</div>
      ) : (
        <pre className="whitespace-pre-wrap font-sans text-sm text-slate-800 leading-relaxed max-h-[70vh] overflow-y-auto">{text.text}</pre>
      )}
    </div>
  );
};
